"use strict";

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Share = function Share(props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? 12 : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 14 : _props$height,
      _props$color = props.color,
      color = _props$color === void 0 ? "#fff" : _props$color;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 12 14",
    scale: width / 12,
    width: width,
    height: height,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.937 8.75a2.35 2.35 0 0 1 1.727.71c.474.475.711 1.05.711 1.728a2.35 2.35 0 0 1-.711 1.726 2.35 2.35 0 0 1-1.727.711 2.35 2.35 0 0 1-1.726-.71 2.35 2.35 0 0 1-.711-1.727c0-.187.017-.364.05-.534L3.96 9.03c-.44.356-.947.534-1.523.534a2.35 2.35 0 0 1-1.726-.711A2.35 2.35 0 0 1 0 7.125c0-.677.237-1.253.71-1.727a2.35 2.35 0 0 1 1.727-.71c.576 0 1.084.177 1.524.533l2.59-1.625a2.714 2.714 0 0 1-.051-.533c0-.678.237-1.253.71-1.727A2.35 2.35 0 0 1 8.938.625a2.35 2.35 0 0 1 1.727.711c.474.474.711 1.05.711 1.727a2.35 2.35 0 0 1-.711 1.726 2.35 2.35 0 0 1-1.727.711 2.355 2.355 0 0 1-1.523-.533l-2.59 1.625c.068.355.068.71 0 1.066l2.59 1.625c.44-.355.948-.533 1.523-.533z",
    id: "share"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    fill: color,
    fillRule: "nonzero",
    xlinkHref: "#share"
  }));
};

var _default = Share;
exports["default"] = _default;
module.exports = exports["default"];